type VerticalRect = {
  top: number;
  bottom: number;
  height: number;
};

export const calculatePageVisibility = (container: VerticalRect, page: VerticalRect) => {
  if (page.height <= 0) return { visibleHeight: 0, depthPercent: 0 };

  const visibleTop = Math.max(page.top, container.top);
  const visibleBottom = Math.min(page.bottom, container.bottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);
  const depthPercent = Math.min(100, Math.max(0, Math.round(((visibleBottom - page.top) / page.height) * 100)));

  return { visibleHeight, depthPercent: visibleHeight ? depthPercent : 0 };
};
